module.exports = __webpack_public_path__ + "static/media/bd-nurse-med-station.a17f5df6.jpg";